import { Directive, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MobileDialogBackButtonService } from '@shared/mobile-dialog-back-button.service';
import { NzModalComponent } from 'ng-zorro-antd/modal';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'nz-modal',
  standalone: false,
})
export class NzModalMobileBackButtonDirective implements OnInit, OnDestroy {
  private readonly nzModal = inject(NzModalComponent);
  private readonly mobileDialogBackButton = inject(MobileDialogBackButtonService);
  private readonly destroy$: ReplaySubject<boolean> = new ReplaySubject(1);

  @Input() mobileBackButtonClose = true;

  public ngOnInit(): void {
    if (!this.mobileDialogBackButton.isPhone()) {
      return;
    }

    const closeOnNavigation = this.nzModal.nzCloseOnNavigation !== false;
    this.nzModal.nzCloseOnNavigation = false;

    this.nzModal.afterOpen.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.mobileDialogBackButton.registerOpenOverlay({
        isOpen: () => this.nzModal.nzVisible,
        close: () => {
          if (!this.canClose()) {
            return false;
          }

          this.nzModal.triggerCancel();
          return true;
        },
        closed: this.nzModal.afterClose,
        dismissable: this.shouldHandleBackButton(),
        navigationClose: closeOnNavigation ? () => this.nzModal.close() : undefined,
      });
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private shouldHandleBackButton(): boolean {
    return this.mobileBackButtonClose !== false && this.canClose();
  }

  private canClose(): boolean {
    return (
      this.nzModal.nzKeyboard !== false && (this.nzModal.nzClosable !== false || this.nzModal.nzMaskClosable !== false)
    );
  }
}
